function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.97168 1L6.20532 6L11.439 1",
  stroke: "#AEAEAE"
});
const SvgDropdown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDropdown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dropdown.7d32d2fa.svg";
export { ForwardRef as ReactComponent };